import React, { useState } from "react";
import Slider from "react-slick";

import 'aos/dist/aos.css';
import '../assets/Header.css';
import '../assets/HeroSection.css';

import EnquiryForm from "./EnquiryForm";
import Whatsapp from "./Whatsapp";

// Images
import panshetMahotsav from '../assets/imgs/hero-banner2.webp';
import sakalpuraskar from '../assets/imgs/sakal-gaurav-puraskar.webp';
import ssg2 from '../assets/events/ssg-2.webp';
import newyear from '../assets/imgs/new-year-hero.webp';
import directorsMsg from '../assets/imgs/directors-msg.png';
import Sawali from '../assets/imgs/Banner/sawali_plots.png';
import vatika from '../assets/imgs/Banner/aatmabodh_vatika.png';
import tamhini from '../assets/imgs/Banner/tamhini_.png';

import comingexpo from '../assets/imgs/Banner/coming_to_expo.png';


// ✅ Custom Next Arrow
function NextArrow(props) {
    const { onClick } = props;
    return (
        <button className="custom-arrow next-arrow" onClick={onClick}>
            Next →
        </button>
    );
}

// ✅ Custom Prev Arrow
function PrevArrow(props) {
    const { onClick } = props;
    return (
        <button className="custom-arrow prev-arrow" onClick={onClick}>
            ← Prev
        </button>
    );
}

function HeroSection() {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const slides = [
        {
            image: comingexpo,
            heading: "Meets Us",
            subheading: "11 & 12 April-2026",
            bullets: ["10:00 AM to 8:00 PM"],
            cta1: "Enquire Now",
        },
        {
            image: vatika,
            heading: "Wellness-Inspired Living at Donje Pune",
            subheading: "Wake up to Sinhagad views and a life of peace, balance & mindfulness.",
            bullets: ["6 Acres of Bungalow Community"],
            cta1: "Enquire Now",
        },
        {
            image: tamhini,
            heading: "Wake Up to Tamhini’s Waterfall Views",
            subheading: "Live where mist, mountains, and waterfalls surround your everyday life.",
            bullets: ["Farmhouse plots @Tamhini"],
            cta1: "Enquire Now",
        },
        {
            image: Sawali,
            heading: "KONDHANPUR – R-ZONE BUNGALOW SOCIETY",
            subheading: "Just 15 minutes from the city… designed for your first bungalow lifestyle",
            bullets: [""],
            cta1: "Enquire Now",
        },
        {
            image: panshetMahotsav,
            heading: "Panshet Mahotsav - 23 Dec 2025",
            subheading: "100+ families explored Waterscape",
            bullets: ["Closed 50% bookings in a single day!"],
            cta1: "Enquire Now",
        },
        {
            image: sakalpuraskar,
            heading: "Samriddhi Group",
            subheading: "सकाळ गौरव गाथा पुरस्कार for Sustainable Development",
            bullets: ["Awarded on 24 June 2025"],
            cta1: "Enquire Now",
        }
    ];

    const sliderSettings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 8000,
        swipe: true,
        touchMove: true,
        pauseOnHover: false,
        adaptiveHeight: true,

        // ✅ Attach custom arrows
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    };

    const handleCloseModal = () => setIsModalVisible(false);

    return (
        <>
            <div className="hero-container">
                <Slider {...sliderSettings}>
                    {slides.map((slide, index) => (
                        <div key={index} className="hero-slide active">
                            <img
                                src={slide.image}
                                alt={slide.heading}
                                className="hero-image"
                            />

                            <div className="hero-slide-content">
                                <h3 className="hero-heading">{slide.heading}</h3>
                                <p className="hero-subheading">{slide.subheading}</p>

                                <ul className="hero-bullets">
                                    {slide.bullets.map((point, i) => (
                                        <li key={i}>• {point}</li>
                                    ))}
                                </ul>

                                {slide.cta1 && (
                                    <div className="hero-buttons">
                                        <button
                                            className="scheduleVisit"
                                            onClick={() => setIsModalVisible(true)}
                                        >
                                            {slide.cta1}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </Slider>

                {/* MODAL */}
                {isModalVisible && (
                    <div className="h-modal-overlay" onClick={handleCloseModal}>
                        <div
                            className="h-modal-content"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className="h-close-modal"
                                onClick={handleCloseModal}
                            >
                                ×
                            </button>
                            <EnquiryForm />
                        </div>
                    </div>
                )}
            </div>

            <div className="short-intro-sg">
                <p className="short-intro-sg-heading">
                    Samriddhi Group Builders & Developers
                </p>
                <p className="short-intro-sg-para">
                    At Samriddhi Group, we believe land is more than property—it's a lifestyle, an inheritance, and a personal sanctuary.
                    <br />
                    Our projects are born from a simple vision:
                    <br />
                    “Let nature enrich life, and let land enrich generations.”
                    <br />
                    From mango farms in Konkan to wellness retreats near Lonavala and riverside escapes near Pune, every project balances three elements:
                    <br />
                    Peaceful living • Smart investing • Emotional connection
                    <br />
                    Whether you're seeking a weekend retreat, a future retirement haven, or a secure long-term investment—Samriddhi Group builds spaces where life flows naturally.
                </p>
            </div>

            <Whatsapp />
        </>
    );
}

export default HeroSection;